<template>
  <div class="p-4">
    <div style="max-width: 700px" class="row">
      <div class="col-sm-8">
        <h2 class="text-2xl font-bold mb-4">Doctor's Notes</h2>
      </div>
      <div class="col-sm-4 d-flex justify-content-end">
        <button @click="showDocNotesModal" class="btn btn-primary">
          🖊 Add Note
        </button>
      </div>
    </div>

    <div style="max-width: 700px" class="card">
      <div
        style="
          background-color: rgb(232, 228, 227);
          margin-bottom: 1px;
          border-radius: 0.7em;
          position: relative;
        "
        class="row p-2"
        v-for="note in notes"
        :key="note.id"
      >
        <div class="col-sm-1">#{{ note.id }}</div>
        <div class="col-sm-11">
          <div>
            <p style="color: black" class="pb-0 mb-0">{{ note.note }}</p>
            <div class="d-flex justify-content-between align-items-center">
              <p style="text-align: start; margin-bottom: 0">
                <span style="color: grey; font-size: smaller">
                  {{ change_utc(note.created_at) }}
                </span>
              </p>
              <div class="note-actions">
                <span
                  @click="editNote(note.id)"
                  style="cursor: pointer; margin-right: 10px; font-size: 1.1rem"
                  title="Edit note"
                >
                  ✏️
                </span>
                <span
                  @click="deleteNote(note.id)"
                  style="cursor: pointer; font-size: 1.1rem; color: #dc3545"
                  title="Delete note"
                >
                  🗑️
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add_doctors_note_modal
      v-if="showNotesModal"
      @close-add-doc-note-modal="closeNotesModal"
      :visit_id="visitId"
      :note_id="noteId"
      @note-added="refresh"
      @note-updated="refresh"
    />
  </div>
</template>

<script>
import add_doctors_note_modal from "./consultation/add_doctors_note_modal.vue";
import { generalApiRequest } from "../../api/apiIndex";
import utc_local_time from "../../timezone/utc_local_time";

export default {
  data() {
    return {
      showNotesModal: false,
      notes: [],
      noteId: null,
    };
  },
  props: {
    visitId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    add_doctors_note_modal,
  },
  methods: {
    change_utc(utc) {
      return utc_local_time(utc);
    },
    closeNotesModal() {
      this.showNotesModal = false;
      this.noteId = null;
    },
    showDocNotesModal() {
      this.noteId = null;
      this.showNotesModal = true;
    },
    editNote(note) {
      this.noteId = note;
      this.showNotesModal = true;
    },
    async deleteNote(noteId) {
      if (confirm("Are you sure you want to delete this note?")) {
        try {
          const url = `doctors-notes/delete/${noteId}`;
          const res = await generalApiRequest(url, "POST", {}, 1);
          if (res && res.status === "success") {
            this.refresh();
          }
        } catch (error) {
          console.error("Failed to delete doctor’s note:", error);
          alert("Failed to delete the note. Please try again.");
        }
      }
    },
    refresh() {
      this.fetchDoctorsNotes();
    },
    async fetchDoctorsNotes() {
      try {
        const url = `doctors-notes/${this.visitId}`;
        const res = await generalApiRequest(url, "GET", {}, 1);
        if (res && res.status === "success") {
          this.notes = res.data;
        }
      } catch (error) {
        console.error("Failed to fetch doctor’s notes:", error);
      }
    },
  },
  mounted() {
    this.fetchDoctorsNotes();
  },
};
</script>

<style scoped>
textarea:focus {
  outline: none;
  border-color: #3182ce;
}

.note-actions {
  display: flex;
  align-items: center;
}

.note-actions span {
  transition: opacity 0.2s;
}

.note-actions span:hover {
  opacity: 0.7;
}
</style>
